import React, { useEffect, useState } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import { fetchRegions } from '../../redux/actions/shipping';
import {
  REGIONS_FAILED,
  REGIONS_REQUESTED,
  REGIONS_RETRIEVED
} from '../../redux/actions/types';
import RTVAutocomplete from './RTVAutocomplete';

const RegionPicker = ({ state, ...props }) => {
  const [loadingRegions, setLoadingRegions] = useState(false);
  const [options, setOptions] = useState([]);
  const regions = useSelector(state => state.shipping.regions);
  const status = useSelector(state => state.shipping.status);
  const regionsState = useSelector(state => state.shipping.regionsState);
  const dispatch = useDispatch();

  const getOption = option => {
    if (typeof option === 'string') {
      const region = options.find(r => r.id === option);
      return region ? region.name : option;
    }
    return option.name;
  };

  useEffect(() => {
    if (!state || state === '') {
      return;
    }
    setOptions([]);
    dispatch(fetchRegions(state, props.carrier, props.action));
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [state]);

  useEffect(() => {
    if (regionsState !== state) {
      return;
    }
    if (status === REGIONS_REQUESTED) {
      setLoadingRegions(true);
    }
    if (status === REGIONS_RETRIEVED) {
      setLoadingRegions(false);
      setOptions(regions);
    }
    if (status === REGIONS_FAILED) {
      setLoadingRegions(false);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [status, regionsState]);

  return (
    <RTVAutocomplete
      {...props}
      options={!state || state === '' ? [] : options}
      getOptionLabel={getOption}
      renderOption={getOption}
      disabled={!state || state === ''}
      loading={loadingRegions}
      loadingText="Cargando localidades..."
      value={options.length > 0 ? props.value : ''}
      getOptionSelected={(option, value) => option.id === value}
    />
  );
};

export default RegionPicker;
